module.exports = __webpack_public_path__ + "img/img-quick-01.c99bbf71.png";